module.exports = __webpack_public_path__ + "static/media/3@2x.1632da9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/3@2x.png
// module id = 1561
// module chunks = 0